import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "../i18n/LanguageProvider";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

function authFetch(url, opts = {}) {
  const token = localStorage.getItem("token");
  return fetch(url, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", ...(opts.headers || {}) },
  });
}

// Legacy-Fallback (für reine Default-Templates ohne Hook-Context, z.B. Server-Tests)
function getTimeGreeting() {
  const h = new Date().getHours();
  if (h < 10) return "Guten Morgen";
  if (h < 17) return "Hallo";
  return "Guten Abend";
}

function resolveGreeting(template, name, timeBased, timeGreeting) {
  if (timeBased) {
    return `${timeGreeting || getTimeGreeting()} ${name}`;
  }
  return template.replace(/\{name\}/g, name);
}

export function useGreeting(user) {
  const { t } = useTranslation();
  const [globalSettings, setGlobalSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const res = await authFetch(`${API}/settings/greeting`);
      if (res.ok) setGlobalSettings(await res.json());
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  if (!user || loading) return { text: "", loading };

  const fullName = user.name || "";
  const firstName = fullName.split(" ")[0] || fullName;

  // User-individual settings take priority, fall back to global, then defaults
  const nameFormat = user.greeting_name_format || globalSettings?.name_format || "first_name";
  const name = nameFormat === "full_name" ? fullName : firstName;
  const template = user.greeting_template || globalSettings?.template || "Hallo {name}";
  const timeBased = user.greeting_time_based !== undefined && user.greeting_time_based !== null
    ? user.greeting_time_based
    : (globalSettings?.time_based ?? true);

  // Übersetzte Tageszeitbegrüßung
  const h = new Date().getHours();
  const greetingKey = h < 10 ? "greeting.good_morning" : h < 17 ? "greeting.good_day" : "greeting.good_evening";
  const timeGreeting = t(greetingKey);

  const text = resolveGreeting(template, name, timeBased, timeGreeting);

  return { text, loading };
}

export { getTimeGreeting, resolveGreeting };
